<script setup>
import { computed } from 'vue';
import { Head } from '@inertiajs/vue3';
import TireVaultLogo from '@/components/Brand/TireVaultLogo';

const props = defineProps({
    status: {
        type: Number,
        default: 500,
    },
});

const known = [403, 404, 419, 429, 500, 503];

const key = computed(() => (known.includes(props.status) ? props.status : 500));

const goBack = () => {
    window.history.go(-1);
};
</script>

<template>
<div class="min-h-screen flex flex-col items-center justify-center bg-canvas px-6 text-center">
    <Head :title="$t('label.error_' + key + '_title')" />

    <TireVaultLogo
        variant="dark"
        :size="34"
        class="mb-10" />

    <p class="font-display font-bold text-7xl text-primary mb-3">{{ key }}</p>
    <h1 class="font-display font-semibold text-xl text-ink mb-2">{{ $t('label.error_' + key + '_title') }}</h1>
    <p class="text-sm text-ink-light max-w-md mb-8">{{ $t('label.error_' + key + '_hint') }}</p>

    <div class="flex gap-3">
        <button
            class="px-4 py-2.5 rounded-lg text-sm font-semibold border border-line bg-surface text-ink hover:border-accent transition"
            @click="goBack">
            {{ $t('label.go_back') }}
        </button>
        <a
            href="/"
            class="px-4 py-2.5 rounded-lg text-sm font-semibold text-white bg-primary hover:bg-primary-dark transition no-underline">
            {{ $t('label.go_to_dashboard') }}
        </a>
    </div>
</div>
</template>
